import { clearAlert } from 'actions';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'store';
import Transition from 'styles/Transition';

const ErrorAlertWithId: React.FC = () => {
  const dispatch = useDispatch();
  const alert = useSelector((state) => state.alerts.alert);

  const [copied, setCopied] = useState(false);

  if (alert === null) {
    return null;
  }

  const { msg, id } = alert;

  const handleCloseAlert = (): void => {
    dispatch(clearAlert());
  };

  const handleCopyErrorId = async (): Promise<void> => {
    if (id) {
      await navigator.clipboard.writeText(id ?? '');
      setCopied(true);
    }
  };

  return (
    <div className="text-center z-alert fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end">
      <Transition
        show
        enter="transition ease-out duration-100 transform"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="transition ease-in duration-75 transform"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <div className="min-w-80 p-4 bg-white shadow-lg rounded-lg pointer-events-auto flex flex-row justify-between gap-4">
          <div className="w-full flex flex-row justify-between gap-2 text-body">
            <span className="text-litlingo-alert">{msg}</span>
            <div className="flex flex-row gap-2">
              <button
                type="button"
                className={`${
                  copied ? 'text-litlingo-alert-medium' : 'text-litlingo-alert'
                } underline focus:outline-none`}
                onClick={handleCopyErrorId}
                disabled={copied}
              >
                {!copied ? 'Copy Error ID' : 'Copied!'}
              </button>
            </div>
          </div>
          <div
            className="flex cursor-pointer h-5"
            role="button"
            aria-hidden="true"
            onClick={handleCloseAlert}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.80005 2.80005L17.36 17.362"
                stroke="#333333"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.36 2.80005L2.80005 17.362"
                stroke="#333333"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </Transition>
    </div>
  );
};

export default ErrorAlertWithId;
